import { Typography, colors } from '@mui/material';
import details from 'details.json';
import { NavLink as RouterLink } from 'react-router-dom';

import { useDynamicBrand } from '../../../context/DynamicBrandContext';

export default function PoweredByFooter() {
  const { config: brandConfig } = useDynamicBrand();
  const brandWebsite =
    brandConfig.contactDetails?.website ?? details?.website ?? '';

  return (
    <Typography
      variant='h6'
      align='center'
      component={RouterLink}
      to={brandWebsite}
      target='_blank'
      sx={{
        display: 'block',
        color: colors.grey[500],
        fontSize: 12,
        mt: 2,
      }}
    >
      Powered by Switch Energy
    </Typography>
  );
}
